// extracted by mini-css-extract-plugin
export default {"dashContainer":"Dashboard_dashContainer__2+wGP","greet":"Dashboard_greet__ejNQ6","dashButton":"Dashboard_dashButton__5aVTg"};